import * as _ from "lodash";
import * as actions from "external/reports/officeStats/actions";
import { initialOfficeData } from "external/reports/officeStats/OfficeData";
//-- Reducer -------------------------------------------------------------------------------------------------------------------------------
export default function externalOfficeStatsReducer(currState = initialOfficeData, baseAction) {
    let stateChanges;
    switch (baseAction.type) {
        case actions.RECIEVED:
            let loadAction = baseAction;
            stateChanges = {
                officeId: loadAction.officeId
            };
            return _.assign({}, currState, stateChanges);
    }
    return currState;
}
